import React from "react";
import * as S from "./safaricom-activate-modal.styled";
import { BaseModalProps } from "@wit/mpesa-ui-components/lib/context/modal/modal.types";
import { Modal, PrimaryButton } from "@wit/mpesa-ui-components";
import styled from "styled-components";
import LoadingIconWhite from "../../icons/loading-white.icon";

interface ISafaricomActivateModalProps extends BaseModalProps {
  setInnerHtml?: boolean;
  isLoading?: boolean;
  primaryBtnId?: string;
  secondaryBtnId?: string;
}

/**
 * Safaricom Activate Modal Component
 */
const SafaricomActivateModal = ({
  primaryAction,
  primaryBtnLabel = "Confirm",
  secondaryAction,
  secondaryBtnLabel = "Cancel",
  setInnerHtml = false,
  title,
  description = "",
  isLoading = false,
  primaryBtnId = "",
  secondaryBtnId = "",
}: ISafaricomActivateModalProps) => {
  return (
    <Modal onBackgroundClick={secondaryAction}>
      <S.ModalContent data-testid="modalContainer">
        <S.ModalTitle>{title}</S.ModalTitle>
        {setInnerHtml ? (
          <S.ModalDescription dangerouslySetInnerHTML={{ __html: description }} />
        ) : (
          <S.ModalDescription>{description}</S.ModalDescription>
        )}

        <S.ModelActionsContainer>
          <S.ButtonContainer>
            <PrimaryButton
              titleLabel={secondaryBtnLabel}
              id={secondaryBtnId}
              onClick={secondaryAction}
              redTheme={false}
            />
          </S.ButtonContainer>
          {!isLoading ? (
            <S.ButtonContainer>
              <PrimaryButton titleLabel={primaryBtnLabel} id={primaryBtnId} onClick={primaryAction} redTheme={true} />
            </S.ButtonContainer>
          ) : (
            <DivLoading>
              <LoadingIconWhite />
            </DivLoading>
          )}
        </S.ModelActionsContainer>
      </S.ModalContent>
    </Modal>
  );
};

export default SafaricomActivateModal;

const DivLoading = styled("div")`
  background-color: ${props => props.theme.palette.red.normal};
  width: 106px;
  border-radius: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;
